import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { IRelatorioCabecalhoEmpresaResponseData } from 'src/app/interfaces/relatorio/EmpresaCabecalhoRelatorio/IRelatorioCabecalhoEmpresaResponseData';
import { ObterEmpresaService } from 'src/app/services/relatorios/obter-empresa/obter-empresa.service';

@Component({
  selector: 'app-cabecalho-relatorio',
  templateUrl: './cabecalho-relatorio.component.html',
  styleUrls: ['./cabecalho-relatorio.component.scss']
})
export class CabecalhoRelatorioComponent implements OnInit {
  private subscriptions$ = new Subscription();
  codigoContrato: string;
  logoEmpresa: boolean;
  empresaRelatorioCabecalho: IRelatorioCabecalhoEmpresaResponseData;
  mesAno: any;
  constructor(
    private obterEmpresaService: ObterEmpresaService,
    private route: ActivatedRoute
  ) {}

  getDadosRelatorioCabecalhoEmpresa() {
    this.subscriptions$.add(
      this.obterEmpresaService
        .postRelatorioEmpresa({
          codigoContrato: this.codigoContrato
        })
        .subscribe({
          next: ({ data }) => {
            this.empresaRelatorioCabecalho = data;
            this.confereLogo(this.empresaRelatorioCabecalho.codigoEmpresa);
          }
        })
    );
  }
  confereLogo(nomeEmpresa: string) {
    if (nomeEmpresa === 'ALTA PERFORMANCE') {
      this.logoEmpresa = true;
    }
  }
  ngOnInit() {
    this.route.params.subscribe(
      (params) => (
        (this.codigoContrato = params['codContrato']),
        (this.mesAno = params['mesAno'])
      )
    );
    this.getDadosRelatorioCabecalhoEmpresa();
  }
}
